import {
  RadioButton,
  RadioButtonGroup,
  Tooltip,
} from 'carbon-components-react';
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/spss-purchase-advisor-self-assessment/locales/messages';
import { segmentsTracking } from 'src/common/lib/tracker';
import './Step.scss';

type Step4Props = {
  pathSelected: string;
  setStatsPkg: React.Dispatch<React.SetStateAction<string>>;
  statsPkg: string;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
};

const Step4 = ({
  pathSelected,
  setStatsPkg,
  statsPkg,
  setIsRequired,
  setQue1Value,
}: Step4Props) => {
  const handleClick = (value: string) => {
    setIsRequired(false);
    setStatsPkg(value);
    setQue1Value('');
    segmentsTracking('CTA Clicked', {
      pageTitle: 'SPSS Purchasing Advisor Self Assessment',
      object: 'SPSS Purchasing Advisor Self Assessment page',
      resultValue: 'CTA clicked',
      CTA: 'License radio button selection',
      location: `${pathSelected} Assessment`,
      action: value,
      field: '',
    });
  };
  const intl = useIntl();

  useEffect(() => {
    setIsRequired(true);
  }, []);

  return (
    <div>
      <div>
        <div className="page_sub_heading padding_8">
          <FormattedMessage {...messages.spss_stats_ques_text} />
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <RadioButtonGroup
              name="Q1-NonTech-group"
              defaultSelected={statsPkg}
              orientation="vertical"
              className="spss-mar5"
            >
              <div className="bx--row radio_text_space">
                <div className="bx--col-lg-13 bx--col-md-7 bx--col-sm-3">
                  <RadioButton
                    labelText={intl.formatMessage(messages.spss_stats_ans1)}
                    value={intl.formatMessage(messages.spss_stats_ans1)}
                    id="Q1A1"
                    onClick={() => handleClick('Perpetual License')}
                  />
                </div>
                <div className="bx--col-lg-3 bx--col-md-1 bx--col-sm-1">
                  <Tooltip
                    className="spss_tooltip"
                    onChange={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                        object: 'SPSS Purchasing Advisor Self Assessment page',
                        resultValue: 'CTA clicked',
                        CTA: 'Perpetual License tooltip',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                    direction={'top'}
                    tabIndex={0}
                  >
                    <span className="slide_text">
                      <FormattedMessage {...messages.landing_tooltip1_info1} />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div className="bx--row radio_text_space ">
                <div className="bx--col-lg-13 bx--col-md-7 bx--col-sm-3">
                  <RadioButton
                    labelText={intl.formatMessage(messages.spss_stats_ans2)}
                    value={intl.formatMessage(messages.spss_stats_ans2)}
                    id="Q1A2"
                    className=""
                    onClick={() => handleClick('Subscription License')}
                  />
                </div>
                <div className="bx--col-lg-3 bx--col-md-1 bx--col-sm-1">
                  <Tooltip
                    onChange={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                        object: 'SPSS Purchasing Advisor Self Assessment page',
                        resultValue: 'CTA clicked',
                        CTA: 'Subscription License tooltip',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                    className="spss_tooltip"
                    direction={'top'}
                    tabIndex={0}
                    style={{ marginTop: '40px' }}
                    triggerText={''}
                  >
                    <span className="slide_text">
                      <FormattedMessage {...messages.landing_tooltip1_info2} />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div className="bx--row radio_text_margin">
                <div className="bx--col-lg-13 bx--col-md-7 bx--col-sm-3">
                  <RadioButton
                    labelText={intl.formatMessage(messages.spss_stats_ans3)}
                    value={intl.formatMessage(messages.spss_stats_ans3)}
                    id="Q1A3"
                    className=""
                    onClick={() => handleClick('SaaS Subscription License')}
                  />
                </div>
                <div className="bx--col-lg-3 bx--col-md-1 bx--col-sm-1">
                  <Tooltip
                    onChange={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: 'SPSS Purchasing Advisor Self Assessment',
                        object: 'SPSS Purchasing Advisor Self Assessment page',
                        resultValue: 'CTA clicked',
                        CTA: 'SaaS Subscription License tooltip',
                        location: `${pathSelected} Assessment`,
                        action: '',
                        field: '',
                      });
                    }}
                    className="spss_tooltip"
                    direction={'top'}
                    tabIndex={0}
                    triggerText={''}
                  >
                    <span className="slide_text">
                      <FormattedMessage {...messages.landing_tooltip1_info3} />
                    </span>
                  </Tooltip>
                </div>
              </div>
            </RadioButtonGroup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
